"use strict";
var onErrorResumeNext_1 = require('../operators/onErrorResumeNext');
exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/rxjs/observable/onErrorResumeNext.js
// module id = ../../../../rxjs/observable/onErrorResumeNext.js
// module chunks = 4